import React from 'react';
import { StyledFrameContent } from './content.styles';
export const FrameContent = ({ children }) => (<StyledFrameContent>
    {children}
  </StyledFrameContent>);
export default FrameContent;
